<template>
  <div style="height: 0;">

    <el-button
      style="float: left;"
      type="primary"
      size="mini"
      icon="el-icon-plus"
      @click="onAdd"></el-button>


    <el-table :data="table"
              stripe
              highlight-current-row
              border
              :empty-text="emptyText"
              @row-click="setNextData"
              style="width: 26%; float: left; margin-left: 20px;
margin-top: 50px">
      <el-table-column prop="id"
                       label="ID"
                       min-width="50"></el-table-column>
      <el-table-column prop="name"
                       :label="labelName"
                       min-width="100">
      </el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       width="150">
        <template slot-scope="scope">
          <el-tooltip class="item"
                      effect="dark"
                      content="查看/修改城市单价"
                      placement="top"
                      :enterable="false">
            <el-button v-if="params.type === 1"
                       icon="sj-icon-city-salary"
                       size="mini"
                       type="primary"
                       circle
                       @click="onEditSalary(scope.row.id)">
            </el-button>
          </el-tooltip>


          <el-button type="primary"
                     icon="el-icon-edit"
                     size="mini"
                     circle
                     @click="onEdit(scope.row.id)"></el-button>
          <el-button type="primary"
                     icon="el-icon-delete"
                     size="mini"
                     circle
                     @click="onDelete(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="新增/编辑市区信息"
      :visible.sync="currentVisible"
      width="40%">
      <el-form ref="form"
               :model="form"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-row class="text item">
          <el-form-item prop="name"
                        label="名称:">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item v-if="params.type === 1"
                        prop="level"
                        label="城市等级:">
            <el-select class="width-max"
                       v-model="form.level"
                       placeholder="请选择">
              <el-option
                v-for="item in options.levels"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="code"
                        label="行政区代码:">
            <el-input v-model="form.region_code"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
      <el-button @click="currentVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="onSubmit()">确 定</el-button>
    </span>
    </el-dialog>

    <el-dialog
      title="新增/编辑城市单价"
      :visible.sync="salaryVisible"
      width="40%">
      <div class="el-dialog-div">
        <el-row style="margin-bottom: 30px">
          <el-col :span="22">
            <span class="receipt-detail">城市名称: {{form.name}}</span>
          </el-col>
          <el-col :span="22">
            <span class="receipt-detail">城市等级: {{form.level}}</span>
          </el-col>
          <el-col :span="22">
            <span class="receipt-detail">行政区代码: {{form.region_code}}</span>
          </el-col>
          <el-col :span="22">
            <span class="receipt-detail">城市接单系数: {{form.city_order_coefficient}}</span>
          </el-col>
        </el-row>
        <el-form v-for="(detailItem, itemIndex) of city_salary"
                 :key="itemIndex"
                 ref="salaryForm"
                 :rules="formRules"
                 :model="detailItem"
                 size="medium"
                 label-width="120px">

          <div class="re-el-form__flex">
            <div class="medium">
              <el-button class="salary-button"
                         type="danger"
                         size="mini"
                         @click="onDelItem(itemIndex)">删除
              </el-button>
                <el-form-item label="任务类型"
                              prop="task_type"
                              class="form-item">
                  <el-select v-model="detailItem.task_type"
                             placeholder="请选择">
                    <el-option
                      v-for="item in taskOptions.type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="城市单价"
                              prop="task_salary"
                              class="form-item">
                  <el-input v-model="detailItem.task_salary"></el-input>
                </el-form-item>
              <hr v-if="itemIndex < city_salary.length - 1"
                  style="border: 1px dashed; color: #999; margin-bottom: 50px">
            </div>
          </div>
        </el-form>
      </div>
      <div>
        <el-button type="primary"
                   size="mini"
                   @click="onAddDetail()"
                   style="margin-bottom: 20px">添加
        </el-button>
      </div>
      <span slot="footer"
            class="dialog-footer">
      <el-button @click="salaryVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="onSubmitSalary()">确 定</el-button>
    </span>
    </el-dialog>
  </div>


</template>

<script>
import { formRules } from '../city-map.rules.js'

export default {
  name: 'CityMap',
  props: {
    labelName: String,
    params: Object,
  },
  data () {
    return {
      formRules,
      table: [],
      emptyText: '',
      currentVisible: false,
      salaryVisible: false,
      form: {
        id: null,
        name: null,
        region_code: null,
        level: null,
        city_order_coefficient: null,
      },
      city_salary: [
        {
          task_salary: null,
          task_type: null
        }
      ]
    }
  },
  created () {
    this.getTableData()
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.cityMap.options,
      taskOptions: state => state.order.options,
    }),
  },
  watch: {
    params: {
      handler (val) {
        this.getTableData()
      },
    },
  },
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    // 省市区列表展示
    getTableData () {
      if (!this.params || JSON.stringify(this.params) === '{}') {
        this.emptyText = '请选择上级目标'
        this.table = []
      } else {
        let params = filter.copyJson(this.params)
        request.common('getCitymapTable', params).then((res) => {
          this.table = res.data

          if (this.table.length === 0) {
            this.emptyText = '没有查询到相关信息'
          }
        }).catch(() => {
          this.table = []
        })
      }
    },
    // 点击父级后展示子级列表
    setNextData (row) {
      if (row.type < 2) {
        let params = {type: row.type + 1, parentid: row.id}
        this.$emit('getParams', params)
      }
    },
    // 添加省市区，市区需点击上一级
    onAdd () {
      if (!this.params || JSON.stringify(this.params) === '{}') {
        this.$message.error('未选择上一级')
        return
      }
      this.form = {
        name: null,
        region_code: null,
        level: null,
      }
      this.currentVisible = true
    },
    // 编辑
    onEdit (id) {
      request.alert('getCitymapDetail', {id: id}).then(({data}) => {
        if (data.region_code === '0') {
          delete data.region_code
        }
        this.form = data
        this.currentVisible = true
      }).catch((res) => {
      })
    },
    onDelete (id) {
      this.$confirm('你确定要删除吗？', '提示', {type: 'warning'}).then(() => {
        request.alert('deleteCitymap', {id: id}).then(({data}) => {
          this.$message.success('删除成功！')


          this.$emit('getParams', Object.assign({}, this.params, {refresh: 1}))
        }).catch((res) => {
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    onSubmit () {
      if (this.form.id) {
        request.alert('updateCitymap', this.form).then(({data}) => {
          this.currentVisible = false
          this.$message.success('提交成功！')
        }).catch((res) => {
        })
      } else {
        this.form.type = this.params.type
        this.form.parentid = this.params.parentid
        request.alert('createCitymap', this.form).then(({data}) => {
          this.currentVisible = false
          this.$message.success('提交成功！')
          this.$emit('getParams', Object.assign({}, this.params, {refresh: 1}))
        }).catch((res) => {
        })
      }
    },
    // 编辑城市单价
    onEditSalary (id) {
      this.city_salary = [
        {
          task_salary: null,
          task_type: null
        }
      ]
      request.alert('getCitymapDetail', {id: id}).then(({data}) => {
        if (data.region_code === '0') {
          delete data.region_code
        }
        this.form = data
        this.salaryVisible = true
        request.alert('getCitySalary', {id: id}).then(({data}) => {
          if (data.length) {
            this.city_salary = data
          }
        }).catch((res) => {
        })
      }).catch((res) => {
      })
    },
    // 提交城市单价
    async onSubmitSalary () {
      if (!this.$refs.salaryForm) {
        this.$message.error('提交内容填写不正确！')
      }
      let promises = []
      for (let form of this.$refs.salaryForm) {
        promises.push(form.validate())
      }
      Promise.all(promises).then(() => {
        let id = this.form.id
        request.common('updateCitySalary', {id: id, city_salary: this.city_salary}).then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          })
          this.salaryVisible = false
        })
      }).catch(() => {
        this.$message.error('提交内容填写不正确！')
      })
    },
    // 添加一条城市单价
    onAddDetail () {
      let params = {
        task_salary: null,
        task_type: null,
      }
      this.city_salary.push(params)
    },
    // 删除一条城市单价
    onDelItem (index) {
      this.city_salary.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.salary-button {
  float: right;
}
.form-item {
  width: 300px;
}


.el-dialog-div {
  height: 50vh;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/city-map/components/CityMap.vue